import { IUseWalletStore } from '@/src/store/global/types';
import {
    SwapOfferCreateTxParams,
    SwapOfferSwapADAxFTTxParams,
    SwapOfferSwapFTxADATxParams
} from '../../Commons';
import { ProtocolEntity } from '../../Entities';
import { SwapOfferEntity } from '../../Entities/SwapOffer.Entity';
import { SmartDBBtnHandlers } from '../index.exports.BtnHandlers.TxApiCalls';
import { SwapOfferTxApiCalls } from './SwapOffer.FrontEnd.Tx.Api.Calls';

export class SwapOfferBtnHandlers extends SmartDBBtnHandlers {
    protected static _Entity = SwapOfferEntity;
    protected static _TxApiCalls = SwapOfferTxApiCalls;

    // #region class methods

    // #endregion class methods

    // #region front end Btn tx handlers

    ///TODO ELIMINAR TODO ESTO Y USAR EL GENERICO useSwapOfferTx hook

    public static async handleBtnCreateTx<T extends SwapOfferEntity>(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        protocol: ProtocolEntity,
        txParams: SwapOfferCreateTxParams
    ): Promise<boolean> {
        return this.handleBtnDoTransaction_V1(
            SwapOfferEntity,
            'Creating Swap Offer...',
            'Create Tx',
            setProcessingTxMessage,
            setProcessingTxHash,
            walletStore,
            txParams,
            SwapOfferTxApiCalls.createTxApi.bind(this)
        );
    }

    public static async handleBtnSwapFTxADATx<T extends SwapOfferEntity>(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        protocol: ProtocolEntity,
        txParams: SwapOfferSwapFTxADATxParams
    ): Promise<boolean> {
        return this.handleBtnDoTransaction_V1(
            SwapOfferEntity,
            'Swaping FT x ADA...',
            'Swap FT x ADA Tx',
            setProcessingTxMessage,
            setProcessingTxHash,
            walletStore,
            txParams,
            SwapOfferTxApiCalls.swapFTxADATxApi.bind(this)
        );
    }

    public static async handleBtnSwapADAxFTTx<T extends SwapOfferEntity>(
        setProcessingTxMessage: (value: string) => void,
        setProcessingTxHash: (value: string) => void,
        walletStore: IUseWalletStore,
        protocol: ProtocolEntity,
        txParams: SwapOfferSwapADAxFTTxParams
    ): Promise<boolean> {
        return this.handleBtnDoTransaction_V1(
            SwapOfferEntity,
            'Swaping ADA x FT...',
            'Swap ADA x FT Tx',
            setProcessingTxMessage,
            setProcessingTxHash,
            walletStore,
            txParams,
            SwapOfferTxApiCalls.swapADAxFTTxApi.bind(this)
        );
    }

    // #endregion front end Btn tx handlers
}
